"use client";

import { useState } from "react";
import Image from "next/image";
import ImageLightbox from "./ImageLightbox";

export default function AuthorAvatar() {
  const [open, setOpen] = useState(false);
  const src = "/images/nguyen-le-giang.webp";
  const alt = "Nguyễn Lê Giang - Tác giả 22 đầu sách Tài chính Ngân hàng, Founder JB.com.vn";

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="relative w-40 h-40 sm:w-[200px] sm:h-[200px] mx-auto sm:mx-0 rounded-xl overflow-hidden shadow-card-md hover:shadow-card-lg transition-all cursor-zoom-in block"
        aria-label="Phóng to ảnh tác giả"
      >
        <Image
          src={src}
          alt={alt}
          fill
          className="object-cover"
          sizes="(max-width: 640px) 160px, 200px"
          priority
        />
      </button>

      <ImageLightbox src={open ? src : null} alt={alt} onClose={() => setOpen(false)} />
    </>
  );
}
